<mat-divider aria-hidden="true" vertical [ngStyle]="{ height: height + 'px' }"></mat-divider>
